( function() {

	const $ = jQuery;

	$('.accordion').click(function() {
		$(this).toggleClass('is-open').children('.accordion-content').slideToggle();
	});

}() );
